import { React, useEffect, useState } from "react";
import Dashboard from "../../assets/icons/dashboard";
import Yupup from "./../../assets/icons/yupupLogo.svg";
import Logout from "./../../assets/icons/logout";
import Ads from "./../../assets/icons/ads";
import Order from "./../../assets/icons/order";
import Business from "../../assets/icons/business";
import BusinessType from "../../assets/icons/businessType";
import Category from "../../assets/icons/category";
import Customer from "../../assets/icons/customer";
import Notification from "../../assets/icons/notification";
import Setting from "../../assets/icons/setting";
import Salesforce from "../../assets/icons/salesforce";
import FAQ from "../../assets/icons/faq";

import colors from "../../share/constants/constants";
import { logout } from "../../api/auth";
import { clearLocalStorage } from "../../authService";
import { Divider, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import { Layout } from "antd";
import { useDispatch } from "react-redux";
import { fetchUser } from "../../store/slices/userSlice";
import PromoCode from "../../assets/icons/promocode";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
const { Sider } = Layout;

const Sidenav = () => {
  const [activeItem, setActiveItem] = useState("new-business");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleItemClick = (itemKey) => {
    if (itemKey === "logout") setActiveItem("logout");
    else setActiveItem(window.location.pathname.split("/")[2]);
  };

  const handleLogout = async () => {
    handleItemClick("logout");
    const res = await logout();
    if (res?.status) {
      clearLocalStorage();
    }
    navigate("/login");
  };
  useEffect(() => {
    dispatch(fetchUser());
    if (activeItem === "logout") setActiveItem("logout");
    else setActiveItem(window.location.pathname.split("/")[2]);
  }, []);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
      collapsed={collapsed}
      onCollapse={(collapsed) => setCollapsed(collapsed)}
      className="position-fixed"
      style={{ overflowY: "auto", height: "100vh" }}
    >
      <div className="demo-logo-vertical" />
      {collapsed ? (
        <MenuOutlined
          onClick={() => setCollapsed(!collapsed)}
          className="text-lg lg:hidden fixed top-4 left-3 z-[999]"
        />
      ) : (
        <CloseOutlined
          onClick={() => setCollapsed(!collapsed)}
          className="text-lg lg:hidden relative top-3 left-3 z-[999]"
        />
      )}

      <div>
        <div className="flex justify-center align-center">
          <img
            src={Yupup}
            className="h-7 mt-4 hidden lg:block"
            alt="Yupup Logo"
          />
        </div>
        <div className="pt-2 lg:pt-0">
          <p className="text-black text-center">
            <Tag>Admin</Tag>
          </p>
        </div>
      </div>

      <Menu
        className="bg-lightLavender h-100 relative text-white  flex flex-col justify-between"
        mode="inline"
      >
        <Menu.Item
          key="dashboard"
          icon={
            <Dashboard
              color={activeItem === "dashboard" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "dashboard"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "dashboard" ? colors.primaryPurple : "transparent",
            color: activeItem === "dashboard" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("dashboard")}
        >
          <Link to="dashboard">Dashboard</Link>
        </Menu.Item>

        <Menu.Item
          key="public-deals"
          icon={
            <Order
              color={activeItem === "public-deals" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "public-deals"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "public-deals"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "public-deals" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("public-deals")}
        >
          <Link to="public-deals">Public Deals</Link>
        </Menu.Item>

        <Menu.Item
          key="new-business"
          icon={
            <Business
              color={activeItem === "new-business" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "new-business"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "new-business"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "new-business" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("new-business")}
        >
          <Link to="new-business">Vendors</Link>
        </Menu.Item>

        <Menu.Item
          key="business-types"
          icon={
            <BusinessType
              color={activeItem === "business-types" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "business-types"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "business-types"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "business-types" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("business-types")}
        >
          <Link to="business-types">Business Types</Link>
        </Menu.Item>
        <Menu.Item
          key="prices"
          icon={
            <BusinessType
              color={activeItem === "prices" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "prices"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "prices"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "prices" ? "white" : colors.black,
            // paddingLeft: "20px", // Adjust the value as needed
            // display: "flex", // To ensure proper alignment of icon and text
            // alignItems: "center",
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("prices")}
        >
          <Link to="prices">Subscriptions</Link>
        </Menu.Item>
        <Menu.Item
          key="orders"
          icon={
            <Order color={activeItem === "orders" ? colors.white : "#202224"} />
          }
          className={`h-5.4 p-1 ${
            activeItem === "orders" ? "active-menu-item" : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "orders" ? colors.primaryPurple : "transparent",
            color: activeItem === "orders" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("orders")}
        >
          <Link to={"orders"}>Orders</Link>
        </Menu.Item>
        <Menu.Item
          key="categories"
          icon={
            <Category
              color={activeItem === "categories" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "categories"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "categories"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "categories" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("categories")}
        >
          <Link to="categories">Categories</Link>
        </Menu.Item>
        <Menu.Item
          key="ads"
          icon={<Ads color={activeItem === "ads" ? colors.white : "#202224"} />}
          className={`h-5.4 ${
            activeItem === "ads" ? "active-menu-item" : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "ads" ? colors.primaryPurple : "transparent",
            color: activeItem === "ads" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("ads")}
        >
          <Link to="ads">Ads</Link>
        </Menu.Item>

        <Menu.Item
          key="customer"
          icon={
            <Customer
              color={activeItem === "customers" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4 ${
            activeItem === "customers"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "customers" ? colors.primaryPurple : "transparent",
            color: activeItem === "customers" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("customers")}
        >
          <Link to="customers">Customers</Link>
        </Menu.Item>
        <Menu.Item
          key="notifications"
          icon={
            <Notification
              color={activeItem === "notifications" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "notifications"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "notifications"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "notifications" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("notifications")}
        >
          <Link to="notifications">Notifications</Link>
        </Menu.Item>
        <Menu.Item
          key="promo-code"
          icon={
            <PromoCode
              color={activeItem === "promo-code" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "promo-code"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "promo-code"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "promo-code" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("promo-code")}
        >
          <Link to="promo-code">Promo Code</Link>
        </Menu.Item>
        <Menu.Item
          key="top-deals"
          icon={
            <Order
              color={activeItem === "top-deals" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "top-deals"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "top-deals"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "top-deals" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("top-deals")}
        >
          <Link to="top-deals">Top Deals Manager</Link>
        </Menu.Item>
        <Menu.Item
          key="cart-discount-rules"
          icon={
            <PromoCode
              color={activeItem === "cart-discount-rules" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4  ${
            activeItem === "cart-discount-rules"
              ? "active-menu-item"
              : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "cart-discount-rules"
                ? colors.primaryPurple
                : "transparent",
            color: activeItem === "cart-discount-rules" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("cart-discount-rules")}
        >
          <Link to="cart-discount-rules">Cart Discount Rules</Link>
        </Menu.Item>

        <Menu.Item
          key="support"
          icon={
            <Salesforce
              color={activeItem === "support" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4 ${
            activeItem === "support" ? "active-menu-item" : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "support" ? colors.primaryPurple : "transparent",
            color: activeItem === "support" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("support")}
        >
          <Link to="/main/support">Support</Link>
        </Menu.Item>
        <Menu.Item
          key="faq"
          icon={
            <FAQ
              color={activeItem === "faq" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4 ${
            activeItem === "faq" ? "active-menu-item" : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "faq" ? colors.primaryPurple : "transparent",
            color: activeItem === "faq" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("faq")}
        >
          <Link to="faq">FAQ</Link>
        </Menu.Item>
        <Menu.Item
          key="profile"
          icon={
            <Setting
              color={activeItem === "profile" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4 ${
            activeItem === "profile" ? "active-menu-item" : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "profile" ? colors.primaryPurple : "transparent",
            color: activeItem === "profile" ? "white" : colors.black,
            marginBottom: "10px",
          }}
          onClick={() => handleItemClick("profile")}
        >
          <Link to="profile">Settings</Link>
        </Menu.Item>

        <Divider className="#6B43E0 h-1px " plain />

        <Menu.Item
          key="logout"
          icon={
            <Logout
              color={activeItem === "logout" ? colors.white : "#202224"}
            />
          }
          className={`h-5.4 ${
            activeItem === "logout" ? "active-menu-item" : "hover:!text-black"
          }`}
          style={{
            backgroundColor:
              activeItem === "logout" ? colors.primaryPurple : "transparent",
            color: activeItem === "logout" ? "white" : colors.black,
            marginBottom: "40px",
          }}
          onClick={handleLogout}
        >
          Logout
        </Menu.Item>
      </Menu>
    </Sider>
  );
};
export default Sidenav;
